import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const Industry = ({ industryTargets, negativeIndustryTargets }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Industry')} includedData={industryTargets} excludedData={negativeIndustryTargets} singularText={i18n.getString(_TL_('industry'))} pluralText={i18n.getString(_TL_('industries'))} />
  );
};

Industry.propTypes = {
  industryTargets: PropTypes.arrayOf(PropTypes.shape({})),
  negativeIndustryTargets: PropTypes.arrayOf(PropTypes.shape({})),
};

Industry.defaultProps = {
  industryTargets: [],
  negativeIndustryTargets: [],
};
